<template>
  <div>
    <md-table
      dir="rtl"
      :value="data"
      class="paginated-table table-striped table-hover mt-25"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="اسم الموظف">
          {{ item.fullName }}
        </md-table-cell>

        <md-table-cell md-label="الرقم المالي">
          {{ item.fileNumber }}
        </md-table-cell>

        <md-table-cell md-label="المرتب">
          {{ item.basicSalary.toLocaleString() }}
        </md-table-cell>
        <md-table-cell md-label="ساعات العمل">
          {{ item.totalWorktime }}
        </md-table-cell>
        <md-table-cell md-label="قيمة ساعة الدوام العادي">
          {{ item.regularShiftManHour.toLocaleString() }}
        </md-table-cell>
        <md-table-cell md-label="قيمة ساعة دوام المناوبة">
          {{ item.nightShiftManHour.toLocaleString() }}
        </md-table-cell>

        <md-table-cell> </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
  name: "GetEmployeesFinancialInfosTable",
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    convert(date) {
      return new Date(date).toLocaleDateString("ar-EG", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
